import { Injectable } from '@angular/core';
import { RepositoryBase } from '../../../shared/infrastructure/Repository';
import { UserPlatformDto } from '../../users/domain/user_platform_dto.entity';
import { LoginRepository } from '../domain/login.repository';
import { LoginDto } from '../domain/login_dto.entity';

@Injectable()
export class LoginRestRepository
  extends RepositoryBase
  implements LoginRepository
{
  public async getVersion(): Promise<string> {
    let result = await this.get(`${this.baseUrl}api/v1/version`);

    if (result.isError ?? true) {
      throw new Error('error');
    }
    return result.data;
  }

  public async login(data: LoginDto): Promise<string> {
    sessionStorage.removeItem('sessionToken');
    let result = await this.post(`${this.baseUrl}api/v1/Login`, data);

    if (result.data == null || (result.isError ?? true)) {
      throw new Error('error');
    }
    return result.data;
  }

  public async logout(): Promise<boolean> {
    let result = await this.get(`${this.baseUrl}api/v1/logout`);
    if (result.isError ?? true) {
      throw new Error('error');
    }
    return result.data;
  }

  public async recover(username: string): Promise<boolean> {
    let result = await this.post(`${this.baseUrl}api/v1/Auth/recover`, {
      username: username,
      signature: 'web',
    });
    if (result.isError ?? true) {
      throw new Error('error');
    }
    return result.data;
  }

  public async recoverChangePassword(
    id: string,
    code: string,
    password: string
  ): Promise<string> {
    let body = { id: id, code: code, password: password };
    let result = await this.post(
      `${this.baseUrl}api/v1/Auth/recoverChangePassword`,
      body
    );
    if (result.isError ?? true) {
      if ((result.data?.error?.data?.error ?? '') == 'ValidationException') {
        throw new Error(JSON.stringify(result.data?.error?.data));
      }
      if (result.data?.error != null) {
        throw new Error(JSON.stringify(result.data?.error));
      }
      throw new Error('error');
    }
    return result.data;
  }

  public async renewToken(): Promise<string> {
    let result = await this.get(`${this.baseUrl}api/v1/Auth/renewToken`);
    if (result.isError ?? true) {
      throw new Error('error');
    }
    return result.data;
  }

  public async getUser(): Promise<UserPlatformDto> {
    let result = await this.get(`${this.baseUrl}api/v1/Auth/getuser`);
    if (result.data == null || (result.isError ?? true)) {
      throw new Error('error');
    }
    return new UserPlatformDto(result.data);
  }

  public async getSessionCode(): Promise<string | null> {
    let result = await this.get(`${this.baseUrl}api/v1/Auth/getSessionCode`);
    if (result.data == null || (result.isError ?? true)) {
      throw new Error('error');
    }
    return result.data;
  }

  public async reSendCode(id: string): Promise<boolean> {
    let result = await this.get(`${this.baseUrl}api/v1/Auth/ReSendCode/${id}`);
    if (result.isError ?? true) {
      if ((result.data?.error?.data?.error ?? '') == 'ValidationException') {
        throw new Error('ValidationException');
      }
      throw new Error('error');
    }
    return result.data;
  }

  public async validateLinkNewMail(id: string, code: string): Promise<string> {
    let body = { id: id, code: code, password: '' };
    let result = await this.post(
      `${this.baseUrl}api/v1/Auth/ValidateLinkNewMail`,
      body
    );
    if (result.isError ?? true) {
      if ((result.data?.error?.data?.error ?? '') == 'ValidationException') {
        throw new Error(JSON.stringify(result.data?.error?.data));
      }
      if (result.data?.error?.data != null) {
        throw new Error(result.data?.error?.data?.message ?? '');
      }
      throw new Error('error');
    }
    return result.data;
  }

  public async validateLinkRecovery(
    id: string,
    codigo: string
  ): Promise<boolean> {
    let body = { id: id, code: codigo, password: '' };
    let result = await this.post(
      `${this.baseUrl}api/v1/Auth/ValidateLinkRecovery`,
      body
    );
    if (result.isError ?? true) {
      if ((result.data?.error?.data?.error ?? '') == 'ValidationException') {
        throw new Error(JSON.stringify(result.data?.error?.data));
      }
      if (result.data?.error != null) {
        throw new Error(JSON.stringify(result.data?.error));
      }
      throw new Error('error');
    }
    return result.data;
  }
}
